import { render, staticRenderFns } from "./ChampionshipCalendarItemWithCompetitionsComponent.vue?vue&type=template&id=75e48ee3&scoped=true"
import script from "./ChampionshipCalendarItemWithCompetitionsComponent.vue?vue&type=script&lang=ts"
export * from "./ChampionshipCalendarItemWithCompetitionsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e48ee3",
  null
  
)

export default component.exports